import promisePrototypeFinallyShim from 'promise.prototype.finally'
import 'mdn-polyfills/String.prototype.startsWith'

const initialize = () => {
  promisePrototypeFinallyShim.shim()
}

export default initialize
